import { createContext } from "react";

const CompromisosContext = createContext({});

export default CompromisosContext;
